const hankaku_eisu = (str: string) => {
  return String.fromCharCode(str.charCodeAt(0) - 0xfee0)
}

const convertToHankaku = (str: string) => {
  str = str.replace(/[Ａ-Ｚａ-ｚ０-９]/g, hankaku_eisu) // 英数
  str = str.replace(/[-－﹣−‐⁃‑‒–—﹘―⎯⏤ーｰ─━]/g, '-') // 色々なハイフンも統一
  str = str.replace(/＠/g, '@') // @マークも親切に統一
  str = str.replace(/　/, ' ')
  str = str.replace(/[ts　]/g, '') // ついでにタブやスペースを消す

  return str
}

export default convertToHankaku
